// Show/hide the other project type field based on the project type selected
class QuoteForm extends HTMLElement {
  constructor() {
    super();
    this.projectTypeSelect = this.querySelector('#QuoteForm-project-type');
    this.otherProjectTypeField = this.querySelector('#other-project-type-field');
    this.otherInput = this.querySelector('#QuoteForm-project-type-other');
  }

  connectedCallback() {
    if (!this.projectTypeSelect) return;

    this.projectTypeSelect.addEventListener('change', () => this.handleProjectTypeChange());
    this.handleProjectTypeChange();
  }

  handleProjectTypeChange() {
    const selectedValue = this.projectTypeSelect.value;
    const isOther = selectedValue === 'Other';

    this.otherProjectTypeField.style.display = isOther ? 'flex' : 'none';

    if (!this.otherInput) return;
    this.otherInput.required = isOther;
    this.otherInput.setAttribute('aria-required', isOther);
  }
}

customElements.define('quote-form', QuoteForm);
